/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastchangedate2Inputs */

const de__field_lastchangedate2 = /** @type {(inputs: _Field_Lastchangedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letztes Änderungsdatum`)
};

/**

* @param {_Field_Lastchangedate2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastchangedate2 = /** @type {((inputs?: _Field_Lastchangedate2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastchangedate2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastchangedate2(inputs)
});
export { _field_lastchangedate2 as "_field_lastChangeDate" }